'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dName$0024 from "./presto.types$-Site-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_SiteTables$$anon$2() {
}
export { $c_Lpresto_SiteTables$$anon$2 as $c_Lpresto_SiteTables$$anon$2 };
$p = $c_Lpresto_SiteTables$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SiteTables$$anon$2;
/** @constructor */
function $h_Lpresto_SiteTables$$anon$2() {
}
export { $h_Lpresto_SiteTables$$anon$2 as $h_Lpresto_SiteTables$$anon$2 };
$h_Lpresto_SiteTables$$anon$2.prototype = $p;
$p.bh = (function(_$22) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$22, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$23) => _$23.E())), $j_presto$002etypes$0024$002dSite$002dName$0024.$m_Lpresto_types$SiteName$().SQ());
});
var $d_Lpresto_SiteTables$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SiteTables$$anon$2, "presto.SiteTables$$anon$2", ({
  Rb: 1,
  H: 1
}));
export { $d_Lpresto_SiteTables$$anon$2 as $d_Lpresto_SiteTables$$anon$2 };
//# sourceMappingURL=presto.-Site-Tables$$anon$2.js.map
